const S3_ROOT = process.env.VUE_APP_BUCKET_URL;

const BYPASS_S3 = /^(\.|http)/i;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const fromBucket = (path, bucket) => {
  if (!path) {
    return path;
  }

  return BYPASS_S3.test(path) ? path : `${bucket}${path}`;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const fromS3 = (path) => fromBucket(path, S3_ROOT);

export default fromS3;
